import { render } from "./basketPage.vue?vue&type=template&id=222e8ca0"
import script from "./basket/script.js?vue&type=script&lang=js&external"
export * from "./basket/script.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__